// src/components/icons/Icons.js

// https://simpleicons.org/
// https://iconscout.com/
// https://freeicons.io/

const Facebook = () => (
  <svg
    className="h-6 w-6"
    fill="#ffffff"
    role="img"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Facebook</title>
    <path d="M9.101 23.691v-7.98H6.627v-3.667h2.474v-1.58c0-4.085 1.848-5.978 5.858-5.978.401 0 .955.042 1.468.103a8.68 8.68 0 0 1 1.141.195v3.325a8.623 8.623 0 0 0-.653-.036 26.805 26.805 0 0 0-.733-.009c-.707 0-1.259.096-1.675.309a1.686 1.686 0 0 0-.679.622c-.258.42-.374.995-.374 1.752v1.297h3.919l-.386 2.103-.287 1.564h-3.246v8.245C19.396 23.238 24 18.179 24 12.044c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.628 3.874 10.35 9.101 11.647Z" />
  </svg>
);

const Twitter = () => (
  <svg
    className="h-6 w-6"
    fill="#ffffff"
    role="img"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>X</title>
    <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z" />
  </svg>
);

const LinkedIn = () => (
  <svg
    className="h-6 w-6"
    fill="#ffffff"
    role="img"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>LinkedIn</title>
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);

const Instagram = () => (
  <svg
    className="h-6 w-6"
    fill="#ffffff"
    role="img"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Instagram</title>
    <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z" />
  </svg>
);

const Whatsapp = () => (
  <svg
    className="h-4 w-4"
    fill="#ffffff"
    role="img"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>WhatsApp</title>
    <path
      d="M6.014 8.00613C6.12827 7.1024 7.30277 5.87414 8.23488 6.01043L8.23339 6.00894C9.14051 6.18132 9.85859 7.74261 10.2635 8.44465C10.5504 8.95402 10.3641 9.4701 10.0965 9.68787C9.7355 9.97883 9.17099 10.3803 9.28943 10.7834C9.5 11.5 12 14 13.2296 14.7107C13.695 14.9797 14.0325 14.2702 14.3207 13.9067C14.5301 13.6271 15.0466 13.46 15.5548 13.736C16.3138 14.178 17.0288 14.6917 17.69 15.27C18.0202 15.546 18.0977 15.9539 17.8689 16.385C17.4659 17.1443 16.3003 18.1456 15.4542 17.9421C13.9764 17.5868 8 15.27 6.08033 8.55801C5.97237 8.24048 5.99955 8.12044 6.014 8.00613Z"
      fill="#128c7e"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 23C10.7764 23 10.0994 22.8687 9 22.5L6.89443 23.5528C5.56462 24.2177 4 23.2507 4 21.7639V19.5C1.84655 17.492 1 15.1767 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM6 18.6303L5.36395 18.0372C3.69087 16.4772 3 14.7331 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C11.0143 21 10.552 20.911 9.63595 20.6038L8.84847 20.3397L6 21.7639V18.6303Z"
      fill="#128c7e"
    />
  </svg>
);

const Recordings = () => (
  <svg
    className="h-6 w-6"
    fill="black"
    role="img"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Grabación</title>
    <path d="M16,10.27,11,7.38A2,2,0,0,0,8,9.11v5.78a2,2,0,0,0,1,1.73,2,2,0,0,0,2,0l5-2.89a2,2,0,0,0,0-3.46ZM15,12l-5,2.89V9.11L15,12ZM12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"></path>
  </svg>
);

const Transcriptions = () => (
  <svg
    className="h-6 w-6"
    fill="black"
    role="img"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Transcripción</title>
    <path d="M13,11H7a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2Zm4-4H7A1,1,0,0,0,7,9H17a1,1,0,0,0,0-2Zm2-5H5A3,3,0,0,0,2,5V15a3,3,0,0,0,3,3H16.59l3.7,3.71A1,1,0,0,0,21,22a.84.84,0,0,0,.38-.08A1,1,0,0,0,22,21V5A3,3,0,0,0,19,2Zm1,16.59-2.29-2.3A1,1,0,0,0,17,16H5a1,1,0,0,1-1-1V5A1,1,0,0,1,5,4H19a1,1,0,0,1,1,1Z"></path>
  </svg>
);

const Feedback = () => (
  <svg
    className="h-6 w-6"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Feedback Inteligencia Artificial</title>
    <rect
      x="2"
      y="2"
      width="20"
      height="20"
      rx="2"
      ry="2"
      fill="none"
      stroke="black"
      strokeWidth="2"
    />
    <text
      x="12"
      y="17"
      textAnchor="middle"
      fontSize="15"
      fontWeight="bold"
      fill="black"
      fontFamily="Arial, sans-serif"
    >
      IA
    </text>
  </svg>
);

const Report = () => (
  <svg
    className="h-6 w-6"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 10C3 6.22876 3 4.34315 4.17157 3.17157C5.34315 2 7.22876 2 11 2H13C16.7712 2 18.6569 2 19.8284 3.17157C21 4.34315 21 6.22876 21 10V14C21 17.7712 21 19.6569 19.8284 20.8284C18.6569 22 16.7712 22 13 22H11C7.22876 22 5.34315 22 4.17157 20.8284C3 19.6569 3 17.7712 3 14V10Z"
      stroke="white"
      strokeWidth="2.0"
    />
    <path d="M8 12H16" stroke="white" strokeWidth="2.0" strokeLinecap="round" />
    <path d="M8 8H16" stroke="white" strokeWidth="2.0" strokeLinecap="round" />
    <path d="M8 16H13" stroke="white" strokeWidth="2.0" strokeLinecap="round" />
  </svg>
);

const Call = () => (
  <svg
    className="h-6 w-6"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5 2C13.5 2 15.8335 2.21213 18.8033 5.18198C21.7731 8.15183 21.9853 10.4853 21.9853 10.4853"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M14.207 5.53564C14.207 5.53564 15.197 5.81849 16.6819 7.30341C18.1668 8.78834 18.4497 9.77829 18.4497 9.77829"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M15.1008 15.0272L15.6446 15.5437V15.5437L15.1008 15.0272ZM15.5562 14.5477L15.0124 14.0312V14.0312L15.5562 14.5477ZM17.9729 14.2123L17.5987 14.8623H17.5987L17.9729 14.2123ZM19.8834 15.312L19.5092 15.962L19.8834 15.312ZM20.4217 18.7584L20.9655 19.275L20.9655 19.2749L20.4217 18.7584ZM19.0012 20.254L18.4574 19.7375L19.0012 20.254ZM17.6763 20.9631L17.75 21.7095L17.6763 20.9631ZM7.8154 16.4752L8.3592 15.9587L7.8154 16.4752ZM3.75185 6.92574C3.72965 6.51212 3.37635 6.19481 2.96273 6.21701C2.54911 6.23921 2.23181 6.59252 2.25401 7.00613L3.75185 6.92574ZM9.19075 8.80507L9.73454 9.32159L9.19075 8.80507ZM9.47756 8.50311L10.0214 9.01963L9.47756 8.50311ZM9.63428 5.6931L10.2467 5.26012L9.63428 5.6931ZM8.3733 3.90961L7.7609 4.3426V4.3426L8.3733 3.90961ZM4.7177 3.09213C4.43244 3.39246 4.44465 3.86717 4.74498 4.15244C5.04531 4.4377 5.52002 4.42549 5.80529 4.12516L4.7177 3.09213ZM11.0632 13.0559L11.607 12.5394L11.0632 13.0559ZM10.6641 19.8123C11.0148 20.0327 11.4778 19.9271 11.6982 19.5764C11.9186 19.2257 11.8129 18.7627 11.4622 18.5423L10.6641 19.8123ZM15.113 20.0584C14.7076 19.9735 14.3101 20.2334 14.2252 20.6388C14.1403 21.0442 14.4001 21.4417 14.8056 21.5266L15.113 20.0584ZM15.6446 15.5437L16.1 15.0642L15.0124 14.0312L14.557 14.5107L15.6446 15.5437ZM17.5987 14.8623L19.5092 15.962L20.2575 14.662L18.347 13.5623L17.5987 14.8623ZM19.8779 18.2419L18.4574 19.7375L19.545 20.7705L20.9655 19.275L19.8779 18.2419ZM8.3592 15.9587C4.48307 11.8778 3.83289 8.43556 3.75185 6.92574L2.25401 7.00613C2.35326 8.85536 3.13844 12.6403 7.27161 16.9917L8.3592 15.9587ZM9.73454 9.32159L10.0214 9.01963L8.93377 7.9866L8.64695 8.28856L9.73454 9.32159ZM10.2467 5.26012L8.98569 3.47663L7.7609 4.3426L9.02189 6.12608L10.2467 5.26012ZM9.19075 8.80507C8.64695 8.28856 8.64626 8.28929 8.64556 8.29002C8.64533 8.29028 8.64463 8.29102 8.64415 8.29152C8.6432 8.29254 8.64223 8.29357 8.64125 8.29463C8.63928 8.29675 8.63724 8.29896 8.63515 8.30127C8.63095 8.30588 8.6265 8.31087 8.62182 8.31625C8.61247 8.32701 8.60219 8.33931 8.5912 8.3532C8.56922 8.38098 8.54435 8.41511 8.51826 8.45588C8.46595 8.53764 8.40921 8.64531 8.36117 8.78033C8.26346 9.0549 8.21022 9.4185 8.27675 9.87257C8.40746 10.7647 8.99202 11.9644 10.5194 13.5724L11.607 12.5394C10.1793 11.0363 9.82765 10.1106 9.7609 9.65511C9.72871 9.43536 9.76142 9.31957 9.77436 9.28321C9.78163 9.26277 9.78639 9.25709 9.78174 9.26437C9.77948 9.26789 9.77498 9.27451 9.76742 9.28407C9.76363 9.28885 9.75908 9.29437 9.75364 9.30063C9.75092 9.30375 9.74798 9.30706 9.7448 9.31056C9.74321 9.31231 9.74156 9.3141 9.73985 9.31594C9.739 9.31686 9.73813 9.31779 9.73724 9.31873C9.7368 9.3192 9.73612 9.31992 9.7359 9.32015C9.73522 9.32087 9.73454 9.32159 9.19075 8.80507ZM10.5194 13.5724C12.0422 15.1757 13.1924 15.806 14.0699 15.9485C14.5201 16.0216 14.8846 15.9632 15.1606 15.8544C15.2955 15.8012 15.4023 15.7387 15.4824 15.6819C15.5223 15.6535 15.5556 15.6266 15.5825 15.6031C15.5959 15.5913 15.6078 15.5803 15.6181 15.5703C15.6233 15.5654 15.628 15.5606 15.6324 15.5562C15.6346 15.554 15.6368 15.5518 15.6388 15.5497C15.6398 15.5487 15.6408 15.5477 15.6417 15.5467C15.6422 15.5462 15.6429 15.5454 15.6432 15.5452C15.6439 15.5444 15.6446 15.5437 15.1008 15.0272C14.557 14.5107 14.5577 14.51 14.5583 14.5093C14.5586 14.509 14.5592 14.5083 14.5597 14.5078C14.5606 14.5069 14.5615 14.506 14.5623 14.5051C14.5641 14.5033 14.5658 14.5015 14.5675 14.4998C14.5708 14.4965 14.574 14.4933 14.577 14.4904C14.5831 14.4846 14.5885 14.4796 14.5933 14.4754C14.6029 14.467 14.61 14.4616 14.6146 14.4584C14.6239 14.4517 14.623 14.454 14.6102 14.459C14.5909 14.4666 14.5001 14.4987 14.3103 14.4679C13.9078 14.4025 13.0391 14.0472 11.607 12.5394L10.5194 13.5724ZM8.98569 3.47663C7.9721 2.04305 5.94388 1.80119 4.7177 3.09213L5.80529 4.12516C6.32812 3.57471 7.24855 3.61795 7.7609 4.3426L8.98569 3.47663ZM18.4574 19.7375C18.1783 20.0313 17.8864 20.1887 17.6026 20.2167L17.75 21.7095C18.497 21.6357 19.1016 21.2373 19.545 20.7705L18.4574 19.7375ZM10.0214 9.01963C10.9889 8.00095 11.0574 6.40678 10.2467 5.26012L9.02189 6.12608C9.44404 6.72315 9.3793 7.51753 8.93377 7.9866L10.0214 9.01963ZM19.5092 15.962C20.3301 16.4345 20.4907 17.5968 19.8779 18.2419L20.9655 19.2749C22.2705 17.901 21.8904 15.6019 20.2575 14.662L19.5092 15.962ZM16.1 15.0642C16.4854 14.6584 17.086 14.5672 17.5987 14.8623L18.347 13.5623C17.2485 12.93 15.8862 13.1113 15.0124 14.0312L16.1 15.0642ZM11.4622 18.5423C10.4785 17.9241 9.43149 17.0876 8.3592 15.9587L7.27161 16.9917C8.42564 18.2067 9.56897 19.1241 10.6641 19.8123L11.4622 18.5423ZM17.6026 20.2167C17.0561 20.2707 16.1912 20.2842 15.113 20.0584L14.8056 21.5266C16.0541 21.788 17.0742 21.7762 17.75 21.7095L17.6026 20.2167Z"
      fill="white"
    />
  </svg>
);

const User = () => (
  <svg
    className="h-6 w-6"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="6" r="4" stroke="white" strokeWidth="2.0" />
    <path
      d="M19.9975 18C20 17.8358 20 17.669 20 17.5C20 15.0147 16.4183 13 12 13C7.58172 13 4 15.0147 4 17.5C4 19.9853 4 22 12 22C14.231 22 15.8398 21.8433 17 21.5634"
      stroke="white"
      strokeWidth="2.0"
      strokeLinecap="round"
    />
  </svg>
);

const UserBlack = () => (
  <svg
    className="h-6 w-6"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="6" r="4" stroke="black" strokeWidth="2.0" />
    <path
      d="M19.9975 18C20 17.8358 20 17.669 20 17.5C20 15.0147 16.4183 13 12 13C7.58172 13 4 15.0147 4 17.5C4 19.9853 4 22 12 22C14.231 22 15.8398 21.8433 17 21.5634"
      stroke="black"
      strokeWidth="2.0"
      strokeLinecap="round"
    />
  </svg>
);

const Analytics = () => (
  <svg
    className="h-6 w-6"
    fill="white"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* TODO: SVG for analytics */}
  </svg>
);

const Groups = () => (
  <svg
    className="h-6 w-6"
    fill="white"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19.73,16.663A3.467,3.467,0,0,0,20.5,14.5a3.5,3.5,0,0,0-7,0,3.467,3.467,0,0,0,.77,2.163A6.04,6.04,0,0,0,12,18.69a6.04,6.04,0,0,0-2.27-2.027A3.467,3.467,0,0,0,10.5,14.5a3.5,3.5,0,0,0-7,0,3.467,3.467,0,0,0,.77,2.163A6,6,0,0,0,1,22a1,1,0,0,0,1,1H22a1,1,0,0,0,1-1A6,6,0,0,0,19.73,16.663ZM7,13a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,7,13ZM3.126,21a4,4,0,0,1,7.748,0ZM17,13a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,17,13Zm-3.873,8a4,4,0,0,1,7.746,0ZM7.2,8.4A1,1,0,0,0,8.8,9.6a4,4,0,0,1,6.4,0,1,1,0,1,0,1.6-1.2,6,6,0,0,0-2.065-1.742A3.464,3.464,0,0,0,15.5,4.5a3.5,3.5,0,0,0-7,0,3.464,3.464,0,0,0,.765,2.157A5.994,5.994,0,0,0,7.2,8.4ZM12,3a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12,3Z" />
  </svg>
);

const Numbers = () => (
  <svg
    className="h-6 w-6"
    fill="white"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* TODO: SVG for numbers */}
  </svg>
);

const Contacts = () => (
  <svg
    className="h-6 w-6"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 7V5C5 3.89543 5.89543 3 7 3H13H19C20.1046 3 21 3.89543 21 5V7V17V19C21 20.1046 20.1046 21 19 21H13H7C5.89543 21 5 20.1046 5 19V17V7Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 12C16 13.6569 14.6569 15 13 15C11.3431 15 10 13.6569 10 12C10 10.3431 11.3431 9 13 9C14.6569 9 16 10.3431 16 12Z"
      stroke="white"
      strokeWidth="2"
    />
    <path
      d="M9 21C9.42546 18.6928 10.52 18 13 18C15.48 18 16.5745 18.6425 17 20.9497"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M3 7H5"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 17H5"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 12H5"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Mic = () => (
  <svg
    className="h-5 w-5"
    fill="black"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 1C9.79086 1 8 2.79086 8 5V12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12V5C16 2.79086 14.2091 1 12 1ZM10 5C10 3.89543 10.8954 3 12 3C13.1046 3 14 3.89543 14 5V12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12V5Z"
      fill="#000000"
    />
    <path
      d="M5 9C5.55228 9 6 9.44771 6 10V12C6 13.5913 6.63214 15.1174 7.75736 16.2426C8.88258 17.3679 10.4087 18 12 18C13.5913 18 15.1174 17.3679 16.2426 16.2426C17.3679 15.1174 18 13.5913 18 12V10C18 9.44771 18.4477 9 19 9C19.5523 9 20 9.44771 20 10V12C20 14.1217 19.1571 16.1566 17.6569 17.6569C16.3938 18.9199 14.7518 19.717 12.9981 19.9375C12.9993 19.9582 13 19.979 13 20V22C13 22.5523 12.5523 23 12 23C11.4477 23 11 22.5523 11 22V20C11 19.979 11.0006 19.9582 11.0019 19.9375C9.2482 19.717 7.60623 18.9199 6.34315 17.6569C4.84285 16.1566 4 14.1217 4 12V10C4 9.44771 4.44772 9 5 9Z"
      fill="#000000"
    />
  </svg>
);

const MicWhite = () => (
  <svg
    className="h-5 w-5"
    fill="white"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 1C9.79086 1 8 2.79086 8 5V12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12V5C16 2.79086 14.2091 1 12 1ZM10 5C10 3.89543 10.8954 3 12 3C13.1046 3 14 3.89543 14 5V12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12V5Z"
      fill="white"
    />
    <path
      d="M5 9C5.55228 9 6 9.44771 6 10V12C6 13.5913 6.63214 15.1174 7.75736 16.2426C8.88258 17.3679 10.4087 18 12 18C13.5913 18 15.1174 17.3679 16.2426 16.2426C17.3679 15.1174 18 13.5913 18 12V10C18 9.44771 18.4477 9 19 9C19.5523 9 20 9.44771 20 10V12C20 14.1217 19.1571 16.1566 17.6569 17.6569C16.3938 18.9199 14.7518 19.717 12.9981 19.9375C12.9993 19.9582 13 19.979 13 20V22C13 22.5523 12.5523 23 12 23C11.4477 23 11 22.5523 11 22V20C11 19.979 11.0006 19.9582 11.0019 19.9375C9.2482 19.717 7.60623 18.9199 6.34315 17.6569C4.84285 16.1566 4 14.1217 4 12V10C4 9.44771 4.44772 9 5 9Z"
      fill="white"
    />
  </svg>
);

const MicOff = () => (
  <svg
    className="h-5 w-5"
    fill="white"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1348_125844)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 9.41421L23.7071 1.70711C24.0976 1.31658 24.0976 0.683417 23.7071 0.292893C23.3166 -0.0976311 22.6834 -0.0976311 22.2929 0.292893L0.292893 22.2929C-0.0976311 22.6834 -0.0976311 23.3166 0.292893 23.7071C0.683417 24.0976 1.31658 24.0976 1.70711 23.7071L7.0946 18.3196C8.2281 19.1995 9.57818 19.7585 11.0019 19.9375C11.0007 19.9582 11 19.979 11 20V22C11 22.5523 11.4477 23 12 23C12.5523 23 13 22.5523 13 22V20C13 19.979 12.9993 19.9582 12.9981 19.9375C14.7518 19.717 16.3938 18.9199 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12V10C20 9.44771 19.5523 9 19 9C18.4477 9 18 9.44771 18 10V12C18 13.5913 17.3679 15.1174 16.2426 16.2426C15.1174 17.3679 13.5913 18 12 18C10.746 18 9.53253 17.6075 8.52379 16.8904L9.96817 15.446C10.5637 15.7978 11.2589 16 12 16C14.2091 16 16 14.2091 16 12V9.41421ZM14 11.4142L11.4818 13.9324C11.6469 13.9765 11.8206 14 12 14C13.1046 14 14 13.1046 14 12V11.4142Z"
        fill="white"
      />
      <path
        d="M8 5C8 2.79086 9.79086 1 12 1C13.983 1 15.6272 2.44198 15.9447 4.33454C16.0361 4.87922 15.6686 5.39484 15.124 5.48622C14.5793 5.5776 14.0637 5.21013 13.9723 4.66546C13.8137 3.72031 12.99 3 12 3C10.8954 3 10 3.89543 10 5V10.5C10 11.0523 9.55229 11.5 9 11.5C8.44771 11.5 8 11.0523 8 10.5V5Z"
        fill="white"
      />
      <path
        d="M6 10C6 9.44771 5.55228 9 5 9C4.44772 9 4 9.44771 4 10V12C4 12.7811 4.11424 13.5505 4.33348 14.2857C4.49129 14.815 5.04827 15.1161 5.57752 14.9583C6.10678 14.8005 6.4079 14.2435 6.25009 13.7143C6.08568 13.1629 6 12.5859 6 12V10Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1348_125844">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const HangUp = () => (
  <svg
    className="h-6 w-6"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 12.8617H7.25L7.25 12.8617L8 12.8617ZM8 13.4782H8.75L8.75 13.4782L8 13.4782ZM6.57997 15.3295L6.36905 14.6097H6.36905L6.57997 15.3295ZM4.57997 15.9156L4.36905 15.1959H4.36905L4.57997 15.9156ZM2 14.0643L2.75 14.0643L2 14.0643ZM2 12.1414H2.75H2ZM2.44083 10.7889L1.86331 10.3104H1.86331L2.44083 10.7889ZM12 7V7.75V7ZM21.3703 9.85601L21.8699 9.29661V9.29661L21.3703 9.85601ZM16 13.25H15.25H16ZM17.7004 15.1625L17.5916 15.9046L17.7004 15.1625ZM19.7004 15.4556L19.8091 14.7135L19.7004 15.4556ZM22 13.5429H21.25V13.5429L22 13.5429ZM22 11.4183H22.75V11.4183L22 11.4183ZM12 11.3963V10.6463V11.3963ZM7.25 12.8617L7.25 13.4782L8.75 13.4782L8.75 12.8617L7.25 12.8617ZM6.36905 14.6097L4.36905 15.1959L4.7909 16.6353L6.7909 16.0492L6.36905 14.6097ZM2.75 14.0643L2.75 12.1414H1.25L1.25 14.0643L2.75 14.0643ZM3.01834 11.2674C3.90179 10.2012 6.51318 7.75 12 7.75V6.25C5.98964 6.25 2.97874 8.96419 1.86331 10.3104L3.01834 11.2674ZM12 7.75C17.233 7.75 19.8648 9.51708 20.8708 10.4154L21.8699 9.29661C20.5944 8.15756 17.6087 6.25 12 6.25V7.75ZM15.25 12.8617V13.25H16.75V12.8617H15.25ZM17.5916 15.9046L19.5916 16.1977L19.8091 14.7135L17.8091 14.4204L17.5916 15.9046ZM22.75 13.5429V11.4183H21.25V13.5429H22.75ZM16 12.8617C16.75 12.8617 16.75 12.8607 16.75 12.8597C16.75 12.8593 16.75 12.8583 16.75 12.8576C16.75 12.8562 16.75 12.8548 16.75 12.8534C16.7499 12.8505 16.7499 12.8475 16.7498 12.8444C16.7497 12.8382 16.7495 12.8316 16.7492 12.8245C16.7485 12.8104 16.7475 12.7946 16.7459 12.7773C16.7428 12.7426 16.7374 12.7016 16.7283 12.6552C16.7102 12.5622 16.6776 12.4484 16.6202 12.3222C16.503 12.0645 16.2941 11.7811 15.9433 11.524C15.2573 11.0214 14.0694 10.6463 12 10.6463V12.1463C13.9306 12.1463 14.7427 12.5039 15.0567 12.734C15.2059 12.8433 15.247 12.9262 15.2548 12.9433C15.2599 12.9544 15.2586 12.9551 15.256 12.9423C15.2548 12.936 15.2533 12.9264 15.2521 12.9132C15.2515 12.9066 15.251 12.8991 15.2506 12.8905C15.2504 12.8862 15.2503 12.8817 15.2502 12.8769C15.2501 12.8745 15.2501 12.872 15.25 12.8695C15.25 12.8682 15.25 12.867 15.25 12.8657C15.25 12.865 15.25 12.864 15.25 12.8637C15.25 12.8627 15.25 12.8617 16 12.8617ZM12 10.6463C9.93056 10.6463 8.74267 11.0214 8.05672 11.524C7.7059 11.7811 7.49703 12.0645 7.37982 12.3222C7.32239 12.4484 7.2898 12.5622 7.27167 12.6552C7.26263 12.7016 7.25722 12.7426 7.25406 12.7773C7.25248 12.7946 7.25147 12.8104 7.25085 12.8245C7.25054 12.8316 7.25032 12.8382 7.25019 12.8444C7.25012 12.8475 7.25008 12.8505 7.25004 12.8534C7.25003 12.8548 7.25002 12.8562 7.25001 12.8576C7.25001 12.8583 7.25 12.8594 7.25 12.8597C7.25 12.8607 7.25 12.8617 8 12.8617C8.75 12.8617 8.75 12.8627 8.75 12.8637C8.75 12.864 8.74999 12.865 8.74999 12.8657C8.74998 12.867 8.74997 12.8682 8.74996 12.8695C8.74993 12.872 8.74989 12.8745 8.74984 12.8769C8.74973 12.8817 8.74958 12.8862 8.7494 12.8905C8.74902 12.8991 8.74849 12.9066 8.74789 12.9132C8.74669 12.9264 8.74518 12.936 8.74395 12.9423C8.74145 12.9551 8.74011 12.9544 8.74518 12.9433C8.75297 12.9262 8.7941 12.8433 8.94328 12.734C9.25733 12.5039 10.0694 12.1463 12 12.1463V10.6463ZM19.5916 16.1977C21.2257 16.4371 22.75 15.2128 22.75 13.5429L21.25 13.5429C21.25 14.2406 20.5953 14.8287 19.8091 14.7135L19.5916 16.1977ZM20.8708 10.4154C21.1133 10.632 21.25 10.9778 21.25 11.4183L22.75 11.4183C22.75 10.6848 22.5191 9.87638 21.8699 9.29661L20.8708 10.4154ZM2.75 12.1414C2.75 11.7741 2.84345 11.4785 3.01834 11.2674L1.86331 10.3104C1.40595 10.8624 1.25 11.5309 1.25 12.1414H2.75ZM15.25 13.25C15.25 14.5971 16.2642 15.71 17.5916 15.9046L17.8091 14.4204C17.1811 14.3284 16.75 13.8157 16.75 13.25L15.25 13.25ZM4.36905 15.1959C3.5319 15.4412 2.75 14.8281 2.75 14.0643L1.25 14.0643C1.25 15.8966 3.05932 17.1428 4.7909 16.6353L4.36905 15.1959ZM7.25 13.4782C7.25 13.9833 6.90669 14.4522 6.36905 14.6097L6.7909 16.0492C7.93988 15.7125 8.75 14.6777 8.75 13.4782L7.25 13.4782Z"
      fill="white"
    />
  </svg>
);

const Close = () => (
  <svg
    className="h-6 w-6"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5 9.50002L9.5 14.5M9.49998 9.5L14.5 14.5"
      stroke="#1C274C"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M7 3.33782C8.47087 2.48697 10.1786 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 10.1786 2.48697 8.47087 3.33782 7"
      stroke="#1C274C"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const Refresh = () => (
  <svg
    className="h-6 w-6"
    viewBox="0 0 32 32"
    fill="black"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M28,16c-1.219,0-1.797,0.859-2,1.766C25.269,21.03,22.167,26,16,26c-5.523,0-10-4.478-10-10S10.477,6,16,6  c2.24,0,4.295,0.753,5.96,2H20c-1.104,0-2,0.896-2,2s0.896,2,2,2h6c1.104,0,2-0.896,2-2V4c0-1.104-0.896-2-2-2s-2,0.896-2,2v0.518  C21.733,2.932,18.977,2,16,2C8.268,2,2,8.268,2,16s6.268,14,14,14c9.979,0,14-9.5,14-11.875C30,16.672,28.938,16,28,16z" />
  </svg>
);

const Copy = () => (
  <svg
    className="h-6 w-6"
    fill="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Copiar</title>
    <path d="M19 3H5c-1.1 0-2 .9-2 2v14h2V5h14V3zm-1 4H9C7.9 7 7 7.9 7 9v10c0 1.1.9 2 2 2h9c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 12H9V9h9v10z" />
  </svg>
);

const Icons = {
  Facebook,
  Twitter,
  LinkedIn,
  Instagram,
  Whatsapp,
  Recordings,
  Transcriptions,
  Feedback,
  Report,
  Call,
  User,
  UserBlack,
  Analytics,
  Groups,
  Numbers,
  Contacts,
  Mic,
  MicWhite,
  MicOff,
  HangUp,
  Close,
  Refresh,
  Copy,
};

export default Icons;
